import { Box, Container, Divider, Flex } from "@chakra-ui/react";
import IconList from "assets/icons/icon-list.svg?react";
import HeaderBar from "components/ui/HeaderBar";
import NavigatorGroup from "components/ui/NavigatorGroup";
import NavigatorItem from "components/ui/NavigatorItem";
import SimpleCard from "components/ui/SimpleCard";
import { PropsWithChildren } from "react";

export default function LayoutParameters({ children }: PropsWithChildren) {
  return (
    <>
      <HeaderBar
        title="Parâmetros"
        description="Define os parâmetros do sistema"
      />

      <Divider />

      <Container flexDir="column">
        <Flex mt="30px" alignItems="flex-start">
          <SimpleCard maxW="252px" overflow="hidden">
            <NavigatorGroup title="Report" mt={0}>
              <NavigatorItem icon={<IconList />} to="/temas">
                Temas
              </NavigatorItem>
              <NavigatorItem icon={<IconList />} to="/tags/CONTENT">
                Tags
              </NavigatorItem>
              <NavigatorItem icon={<IconList />} to="/pls">
                Proposições Legislativas
              </NavigatorItem>
              <NavigatorItem icon={<IconList />} to="/parlamentares">
                Parlamentares
              </NavigatorItem>
            </NavigatorGroup>
            <NavigatorGroup title="Listas de Disparo">
              <NavigatorItem icon={<IconList />} to="/tags/LIST">
                Tags
              </NavigatorItem>
            </NavigatorGroup>
          </SimpleCard>

          <Box w="full" ml="50px">
            {children}
          </Box>
        </Flex>
      </Container>
    </>
  );
}
